import React from 'react';

export default function ContestCards({ coops, contests }) {
  return (
    <section className="section section--xl u--padding-top-40  u--padding-bottom-40">
      <div
        data-container-size="xl"
        className="section__border section__border--padding container"
        style={{ maxWidth: 1226 }}
      >
        <div className="container container--xl">
          <div className="callout__container">
            <div className="grid callout__grid card__grid">
              {contests &&
                contests.map((contest) => {
                  const contestLink =
                    contest.ext_link && contest.ext_link_url
                      ? contest.ext_link_url
                      : contest.url;
                  const contestTarget =
                    contest.ext_link && contest.ext_link_url
                      ? contest.ext_link_url
                      : contest.url;
                  const contestImgSrc =
                    contest.override && contest.override_img
                      ? contest.override_img
                      : contest.image;
                  const contestTitle = contest.alt_title
                    ? contest.alt_title
                    : contest.title;
                  const contestFlag =
                    contest.flag && contest.flag_text ? (
                      <div className="callout__image-flag">
                        {contest.flag_text}
                      </div>
                    ) : (
                      ''
                    );

                  return (
                    <div
                      key={contest.id}
                      className="grid__col-xs-12 grid__col-lg-4 u--padding-bottom-0"
                    >
                      <a
                        href={contestLink}
                        target={contestTarget}
                        className="callout__contest callout--slim"
                      >
                        <div className="callout__image">
                          <img src={contestImgSrc} alt={contest.alt} />
                          {contestFlag}
                        </div>
                        <div className="callout__body">
                          <p className="callout__category">{contest.kicker}</p>
                          <h6
                            className="callout__title"
                            dangerouslySetInnerHTML={{ __html: contestTitle }}
                          />
                          <div href={contest.url} className="callout__link">
                            Enter Now<i className="icon-arrow-right-blue"></i>
                          </div>
                        </div>
                      </a>
                    </div>
                  );
                })}
              {coops &&
                coops.map((coop) => {
                  const coopImgSrc = coop.image
                    ? coop.image
                    : '/app/themes/wlion/images/coop-default.jpg';
                  const coopTitle = coop.id
                    ? coop.title
                    : 'Your Local Electric Co-op';
                  const coopLinkText = coop.id ? 'See More' : 'Select a Co-op';

                  return (
                    <div
                      key={coop.id}
                      className="grid__col-xs-12 grid__col-lg-4 u--padding-bottom-0"
                    >
                      <a
                        href="/my-coop"
                        className="callout__contest callout--slim"
                      >
                        <div className="callout__image">
                          <img src={coopImgSrc} alt={coop.alt} />
                        </div>
                        <div className="callout__body">
                          <p className="callout__category">My Co-op</p>
                          <h6 className="callout__title">
                            See More From {coopTitle}
                          </h6>
                          <div href="/my-coop" className="callout__link">
                            {coopLinkText}
                            <i className="icon-arrow-right-blue"></i>
                          </div>
                        </div>
                      </a>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
